import React from 'react'
import _ from 'underscore'
import { marked } from 'marked'
import { Button } from '@/components/ui/button'

class EmailPreview extends React.Component {

  onEdit = () => {
    this.props.onEdit()
  }

  onSend = () => {
    this.props.onSend()
  }

  render() {
    const email = this.props.email || {}
    const email_content = email.content || ''
    const email_subject = email.subject || ''

    // Markdown collapses 3+ consecutive newlines into a single paragraph
    // break, so multiple blank lines in the textarea would otherwise vanish
    // in the preview. Insert a &nbsp; paragraph for each extra blank line so
    // marked produces a real <p> we can space with margin. (Same approach as
    // tm2-admin's EmailPreview.)
    const preserveBlankLines = (text) =>
      text.replace(/\n{3,}/g, (run) => '\n\n' + '&nbsp;\n\n'.repeat(run.length - 2))

    // Tailwind's preflight zeroes <p>/<h>/<blockquote> margins, so marked's
    // paragraph breaks collapse in the preview. Add bottom spacing back, and
    // pre-wrap so inline runs of spaces don't get collapsed.
    const preserveWhitespace = (html) =>
      html
        .replace(
          /<(p|h[1-6]|blockquote)(\s|>)/gi,
          '<$1 style="white-space:pre-wrap;margin:0 0 1em 0"$2'
        )
        .replace(
          /<(li)(\s|>)/gi,
          '<$1 style="white-space:pre-wrap"$2'
        )

    let content = marked(preserveBlankLines(email_content))
    content = content.replace(/<a\ /gi, "<a target='_blank' ")
    content = preserveWhitespace(content)

    let signature = email.signature || ''
    signature = signature.replace(/<a\ /gi, "<a target='_blank' ")
    signature = preserveWhitespace(signature)

    return (
      <div className="grid gap-4">
        <div className="rounded-[10px] border border-border bg-muted/30 p-4">
          {(email_subject.length > 0) ?
            <p className="mb-4 text-sm font-semibold">
              {email_subject}
            </p>
            : null
          }
          <div className="markdown mb-4 text-sm" dangerouslySetInnerHTML={{ __html: content }}>
          </div>
          <div className="text-sm" dangerouslySetInnerHTML={{ __html: signature }}>
          </div>
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" size="sm" onClick={this.onEdit}>Edit</Button>
          <Button size="sm" onClick={this.onSend}>Send email</Button>
        </div>
      </div>
    )
  }
}

export default EmailPreview
